import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a0661ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "player-com" }
const _hoisted_2 = { class: "player-wrap" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "no-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("video", {
        id: `videoElement${_ctx.id}`,
        class: "video",
        muted: "",
        controls: ""
      }, null, 8, _hoisted_3)
    ], 512), [
      [_vShow, _ctx.url]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
      [_vShow, !_ctx.url]
    ])
  ]))
}